module.exports = "pegasus/assets/facebook-chiclet.png";